import { useIntl } from 'react-intl';
import { SearchIllustration } from '@tlx/atlas';
import { getContextId } from '@tlx/astro-shared';
import { TableEmptyState } from '@Component/Table/Table.utils.tsx';

export function TableEmptyCreateReimbursement() {
    const intl = useIntl();

    return (
        <TableEmptyState
            titleMessage={intl.formatMessage({
                id: 'tsk_filter_no_reimbursement_payments',
            })}
            descriptionMessage={intl.formatMessage({
                id: 'tsk_filter_results_try_create_reimbursement_payment',
            })}
            buttonContent={intl.formatMessage({
                id: 'tsk_text_create_reimbursement_payment',
            })}
            illustration={<SearchIllustration size={'small'} />}
            onClickAction={() => {
                window.open(`/execute/reimbursementMenu?contextId=${getContextId()}#reimbursement`);
            }}
        />
    );
}
